<template>
  <!-- 车辆编辑 -->
  <el-dialog
    title="车辆编辑"
    :visible.sync="editVisible"
    width="700px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="from-body">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="auto"
        :rules="rules"
        class="demo-ruleForm"
      >
        <el-form-item label="车辆编码">
          <el-input v-model="ruleForm.bikeCode" disabled></el-input>
        </el-form-item>
        <!-- 车辆类别 -->
        <el-form-item
          :label="$t('pages.equipment.text5')"
          prop="bikeCategoryId"
        >
          <el-select
            v-model="ruleForm.bikeCategoryId"
            :placeholder="$t('public.text5')"
            @change="selectBikeCategory"
          >
            <el-option
              v-for="(item, index) in belongCategoryList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 车辆型号 -->
        <el-form-item
          :label="$t('pages.equipment.text6')"
          prop="belongBikeTypeId"
        >
          <el-select
            v-model="ruleForm.belongBikeTypeId"
            :placeholder="$t('public.text5')"
          >
            <el-option
              v-for="(item, index) in firmwareManagementListBikeType"
              :key="index"
              :label="item.bikeTypeName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备通讯id" prop="deviceCode">
          <el-input v-model="ruleForm.deviceCode"/>
        </el-form-item>
        <el-form-item label="车架号" prop="bikeFrameSn">
          <el-input v-model="ruleForm.bikeFrameSn"/>
        </el-form-item>
        <el-form-item label="蓝牙MAC" prop="mainBleMac">
          <el-input v-model="ruleForm.mainBleMac"/>
        </el-form-item>
        <el-form-item label="蓝牙密钥" prop="mainBleKey">
          <el-input v-model="ruleForm.mainBleKey"/>
        </el-form-item>
        <el-form-item label="货柜码" prop="logisticsOrder">
          <el-input v-model="ruleForm.logisticsOrder"/>
        </el-form-item>
        <el-form-item label="销售单号" prop="saleNo">
          <el-input v-model="ruleForm.saleNo"/>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t("button.cancel") }}</el-button>
      <el-button type="primary" @click="submit">{{
        $t("button.determine")
      }}</el-button>
    </span>
  </el-dialog>
</template>


<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      ruleForm: {
        bikeCategoryId: "", //车辆类别
        belongBikeTypeId: "", //车辆型号
        bikeCode: "", //车辆编码
        deviceCode: "", //设备编码
        bikeFrameSn: "", //车架号
        mainBleMac: "", //Mac
        mainBleKey: "", //蓝牙密钥
        logisticsOrder: "", //货柜码
        saleNo: "", //销售单号
      },
      firmwareManagementListBikeType: [],
      rules: {
        bikeCategoryId: {
          required: true,
          message: this.$t("pages.equipment.text150"), //请选择车辆类别
          trigger: "change",
        },
        belongBikeTypeId: {
          required: true,
          message: this.$t("pages.equipment.text64"), //请选择车辆型号
          trigger: "change",
        },
       /*  deviceCode: {
          required: true,
          message: "请输入设备编码", //
          trigger: "blur",
        }, */
        bikeFrameSn: {
          required: true,
          message: "请输入车架号", //
          trigger: "blur",
        },
        mainBleMac: {
          required: true,
          message: "请输入Mac地址", //
          trigger: "blur",
        },
        mainBleKey: {
          required: true,
          message: "请输入蓝牙密钥", //
          trigger: "blur",
        },
       /*  logisticsOrder: {
          required: true,
          message: "请输入货柜码", //
          trigger: "blur",
        },
        saleNo: {
          required: true,
          message: "请输入销售单号", //
          trigger: "blur",
        }, */
      },
    };
  },
  // 监听弹窗类型
  watch: {
    editVisible(newValue) {
      if (newValue) {
        console.log(this.info);
        this.ruleForm.bikeCode = this.info.bikeCode;
        this.ruleForm.deviceCode = this.info.deviceCode;
        this.ruleForm.bikeFrameSn = this.info.bikeFrameSn;
        this.ruleForm.mainBleMac = this.info.bleMac;
        this.ruleForm.logisticsOrder = this.info.logisticsOrder;
        this.ruleForm.saleNo = this.info.saleNo;
        this.ruleForm.mainBleKey = this.info.bleKey;
        for (let i in this.belongCategoryList) {
          if (this.info.bikeCategoryName == this.belongCategoryList[i].name) {
            this.ruleForm.bikeCategoryId = this.belongCategoryList[i].id;
            this.firmwareManagementListAllBikeType();
          }
        }
        for (let y in this.belongBikeTypeList) {
          if (
            this.info.bikeTypeName == this.belongBikeTypeList[y].bikeTypeName
          ) {
            this.ruleForm.belongBikeTypeId = this.belongBikeTypeList[y].id;
          }
        }
      }
    },
  },
  computed: {
    ...mapState(["platformData"]),
  },
  mounted() {},
  props: ["editVisible", "info", "belongCategoryList", "belongBikeTypeList"],
  methods: {
    //选择车辆类别
    selectBikeCategory() {
      this.ruleForm.belongBikeTypeId = null;
      this.firmwareManagementListAllBikeType();
    },
    //查询车辆型号（筛选）
    firmwareManagementListAllBikeType() {
      let str = "";
      str = "?bikeCategoryId=" + this.ruleForm.bikeCategoryId;
      this.request.firmwareManagementListAllBikeType(str).then((res) => {
        this.firmwareManagementListBikeType = res.data;
      });
    },
    //关闭弹窗
    handleClose() {
      this.ruleForm = {
        bikeCategoryId: "", //车辆类别
        belongBikeTypeId: "", //车辆型号
        bikeCode: "", //车辆编码
        deviceCode: "", //设备编码
        bikeFrameSn: "", //车架号
        mainBleMac: "", //Mac
        mainBleKey: "", //蓝牙密钥
        logisticsOrder: "", //货柜码
        saleNo: "", //销售单号
      };
      this.firmwareManagementListBikeType = [];
      this.$refs["ruleForm"].resetFields();
      this.$emit("editClose");
    },
    //提交
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.request
            .equipmentListCompile(this.ruleForm)
            .then(() => {
              this.$message.success(this.$t("public.text9"));
              this.$emit("equipmentList");
              this.handleClose();
            })
            .catch(() => {});
        }
      });
    },
  },
};
</script>

<style scoped>
.from-body {
  padding: 0 40px;
  box-sizing: border-box;
  width: 80%;
}
.firmware-content {
  display: flex;
}
.firmware-content a {
  margin-right: 20px;
}
</style>